var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "label-box",
    style: _vm.labelStyle
  }, [_vm._t("default", [_c('span', [_vm._v(_vm._s(_vm.label))])])], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }